export default __webpack_public_path__ + "images/0b57793d62b93911070ec2a186755243-yeah-buoy.svg";